import { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import { colors } from "../../assets/colors";
import {
  useSectionCursor,
  useCursorHandlers,
  CursorContext,
} from "../general/Cursor";
import {
  spring2026PortfolioInfo,
  fall2025PortfolioInfo,
} from "../../assets/currentPortfolioInfo";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';
import { FaLinkedin } from "react-icons/fa"
import '../../styles.css';
import { EffectCards, Navigation } from 'swiper/modules';
import claySeifertHeadshot from '../../assets/headshots/ClaySeifert_Headshot.jpg';
import seyeonHanHeadshot from '../../assets/headshots/SeyeongHan_Headshot.jpg';
import aakritiKamalHeadshot from '../../assets/headshots/Aakriti_Headshot.png';
import adolfoGarcialHeadshot from '../../assets/headshots/Adolfo_Headshot.jpg'
import adityaPrasadHeadshot from '../../assets/headshots/Aditya_Headshot.jpeg';
import waltBoxwellHeadshot from '../../assets/headshots/WaltBoxwell_Headshot.png';
import annaFabrizioHeadshot from '../../assets/headshots/Anna Fabrizio Headshot.jpeg';
import tylerMcClintockHeadshot from '../../assets/headshots/TylerMcClintock_Headshot.jpg';
import shreyasSatewarHeadshot from '../../assets/headshots/ShreyasSatewar_Headshot.jpeg';
import milesNevinsHeadshot from '../../assets/headshots/MilesNevins_Headshot.jpg';
import joseYrigoyenHeadshot from '../../assets/headshots/JoseYrigoyen_Headshot.jpg';
import devRandalpuraHeadshot from '../../assets/headshots/DevRandalpura_Headshot.jpeg';
import rohanPatelHeadshot from '../../assets/headshots/RohanPatel_Headshot.jpg';
import shvetanKattaHeadshot from '../../assets/headshots/ShvetanKatta_Headshot.jpg';

// Fall 2025 Cohort
import erikaBsumekHeadshot from '../../assets/headshots/ErikaBsumek_Headshot.jpg';
import stephenHerreraHeadshot from '../../assets/headshots/StephenHerrera_Headshot.jpg';
import shreyanKattaHeadshot from '../../assets/headshots/ShreyanKatta_Headshot.jpg';
import parthMehtaHeadshot from '../../assets/headshots/ParthMehta_Headshot.jpg';
import harshithSadhuHeadshot from '../../assets/headshots/HarshithSadhu_Headshot.jpg';
import kevinHartzogHeadshot from '../../assets/headshots/KevinHartzog_Headshot.jpg';
import avanishShilpiHeadshot from '../../assets/headshots/AvanishShilpi_Headshot.png';
import ivyFanHeadshot from '../../assets/headshots/IvyFan_Headshot.jpg';
import coleNevinsHeadshot from '../../assets/headshots/ColeNevins_Headshot.jpg';
import { LuArrowRightCircle, LuArrowLeftCircle, LuArrowUpCircle, LuArrowDownCircle } from "react-icons/lu";

// Spring 2026 Cohort
import saahilSinhaHeadshot from '../../assets/headshots/SaahilSinhaHeadshot.png';
import jonathanTeubalHeadshot from '../../assets/headshots/JonathanTeubalHeadshot.jpg';
import ofriElbaumHeadshot from '../../assets/headshots/OfriElbaumHeadshot.jpg';
import yuxuanCaoHeadshot from '../../assets/headshots/YuxuanCaoHeadshot.png';
import viviDengHeadshot from '../../assets/headshots/ViviDengHeadshot.png';
import andreSandovalHeadshot from '../../assets/headshots/AndreSandovalHeadshot.png';
import chaseErikssonHeadshot from '../../assets/headshots/ChaseErikssonHeadshot.png';
import gabrielPatinoHeadshot from '../../assets/headshots/GabrielPatinoHeadshot.png';
import lukeZunamonHeadshot from '../../assets/headshots/LukeZunamonHeadshot.jpg';

const COHORT_TABS = [
  { id: "sp26", label: "Spring 2026 Cohort", companies: spring2026PortfolioInfo },
  { id: "fa25", label: "Fall 2025 Cohort", companies: fall2025PortfolioInfo },
];

/** Matches `PresentCohortContainer` / `PresentMobileCohortContainer` breakpoint (976px). */
function useCohortDesktopLayout() {
  const [desktop, setDesktop] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(min-width: 976px)").matches
      : true
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(min-width: 976px)");
    const onChange = () => setDesktop(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return desktop;
}

const SectionContainer = styled.div`
  width: 100vw;
  min-height: 150vh;
  background-color: ${colors.white};
  display: flex;
  justify-content: start;

  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  align-content: center;
  position: sticky;
  flex-wrap: wrap;
  top: -1px;
  max-width: 100%;
  media only screen and (max-width: 700px) {
    min-height: 90vh;
  }
`;

const PresentCohortContainer = styled.div`
  margin-top: 25px;
  display: none;
  width: 100%;
  justify-content: space-evenly;
  margin: 50px;
  @media only screen and (min-width: 976px) {
    display: flex;
  }
`;

const PresentMobileCohortContainer = styled.div`
  height: 100%;
  display: flex;
  width: fit-content;
  padding: 5px;
  justify-content: center;
  @media only screen and (min-width: 976px) {
    display: none;
  }
`;
const CohortSectionHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const CohortScreenReaderTitle = styled.h2`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

const CohortTabList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  column-gap: 1.1em;
  row-gap: 0.35em;
  margin: 0;
  padding: 0;
`;

const CohortTab = styled.button`
  display: inline;
  font: inherit;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  text-align: center;
  font-size: 4vmin;
  font-family: ReadexPro, sans-serif;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${colors.red};
  text-transform: uppercase;
  opacity: ${({ $active }) => ($active ? 1 : 0.42)};
  text-decoration: ${({ $active }) => ($active ? "underline" : "none")};
  text-decoration-thickness: 2px;
  text-underline-offset: 0.25em;
  letter-spacing: 0.02em;
  @media only screen and (max-width: 700px) {
    font-size: 5.5vmin;
  }
  &:focus-visible {
    outline: 2px solid ${colors.red};
    outline-offset: 3px;
  }
`;

const CohortPanel = styled.section`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  /* Keeps cards + detail row from growing the page when Swiper re-inits */
  min-height: 520px;
  @media only screen and (max-width: 975px) {
    min-height: 0;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  font-size: 3.2vmin;
  font-family: ReadexPro, Helvetica, sans-serif;
  margin: 0;
  padding: 0;
  color: ${colors.black};
  line-height: 1.6;
  font-weight: 300;
  @media only screen and (max-width: 700px) {
    font-size: 4vmin;
  }
  flex-wrap: wrap;
  justify-content: space-evenly;
`;

const LogoImg = styled.img`
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
`;

const LogoImgMobile = styled.img`
  object-fit: contain;
  margin-left: 5px;
  align-items: center;
  width: 20%;
  height: 20%;
`;

const LogoCaption = styled.div`
  font-size: 3vmin;
  margin: 0;
  padding: 0;
  font-weight: 400;
  text-align: center;
  font-family: ReadexPro, sans-serif;
`;

const L = styled.div`
 display: flex;
 flex-direction: column;
 width: 100%;
 height: 100%;
 justify-content: space-evenly;
 align-items: center;
 
`;

const LogoImgContainer = styled.div`
  border-radius: 18px;
  background-color: #FFFFFF;
  display: flex;
  width: 95%;
  height: 75%;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 1000px) {
    background-color: transparent;
    width: 50%;
    height: 50%;
    margin: 0;
  }
`;

const SwiperContainer = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;


const DescriptionContainer = styled.div`
  width: 53%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const SCContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 420px;
  background-color: rgb(240,240,240);
  border-radius: 20px;
`;

const InnerSCContainer = styled.div`
  padding: 0px 10px 0px 10px;
  border: 1.5px solid ${colors.white};
  background-color: ${colors.white};
  border-radius: 20px;
  width: 95%;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const InnerSCContainerAlt = styled.div`
  padding: 0px 10px 0px 10px;
  border: 1.5px solid ${colors.white};
  background-color: ${colors.white};
  border-radius: 20px;
  width: 95%;
  height: 90%;
  display: flex;
  flex-direction: row;
`;

const InnerSCContainerMobile = styled.div`
  padding: 5px 5px 5px 5px;
  border: 1.5px solid ${colors.white};
  background-color: ${colors.white};
  border-radius: 20px;
  width: 92%;
  height: 92%;
  flex-direction: column;
`;

const StartupTitle = styled.h1`
  font-size: 7vmin;
  font-weight: bold;
  font-family: ReadexPro, sans-serif;
  color: ${colors.black};
  text-align: center;
  letter-spacing: -3px;
  margin-bottom: 0px;
`;

const StartupTitleAlt = styled.h1`
  font-weight: bold;
  font-family: ReadexPro, sans-serif;
  color: ${colors.black};
  text-align: left;
  letter-spacing: -3px;
  margin-left: 30px;
  margin-bottom: 0px;
`;

const StartupTitleMobile = styled.h1`
  font-size: 7.5vmin;
  font-weight: bold;
  font-family: ReadexPro, sans-serif;
  color: ${colors.red};
  align-items: center;
  text-align: left;
  letter-spacing: -2px;
  margin-top: 5px;
  margin-bottom: 0px;
  margin-right: 5px;
`;

const StartupHeader = styled.h1`
  display: flex;
  justify-content: center;
  font-size: 4vmin;
  font-weight: 400;
  text-align: left;
  font-family: ReadexPro, sans-serif;
  color: ${colors.black};
`;

const TitleRowMobile = styled.div`
  width: 100%;
  display: flex;
  margin-top: 2px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${colors.red};
`;

const SCMobileContainer = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: column;
  padding: 0px;
  margin-top: 0px;
  margin-bottom: 2px;
  width: 100%;
  height: 100%;
  color: ${colors.black};
`;

const Logo = ({ src, name, onClick}) => {
  const { setCursor } = useContext(CursorContext);

  const handleMouseEnter = () => setCursor({ active: true, color: colors.red });
  const handleMouseLeave = () => setCursor({ active: false, color: "black" });
  return (
    <L onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <LogoImgContainer>
        <LogoImg src={src} />
      </LogoImgContainer>
      <LogoCaption >{ name }</LogoCaption>
    </L>
  );
};

const LogoMobile = ({ src }) => {

  return (
      <LogoImgMobile src={src} />
  );
};


const SwiperArrowsAndProgress = ({ children }) => {
  const { setCursor } = useContext(CursorContext);
  const handleMouseEnter = () => setCursor({ active: true, color:  `${colors.gray}` });
  const handleMouseLeave = () => setCursor({ active: false, color: `${colors.black}` });
  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-evenly' }}>
      {children}
    </div>
  );
};

const SwiperArrowsAndProgressTablet = ({ children }) => {
  const { setCursor } = useContext(CursorContext);
  const handleMouseEnter = () => setCursor({ active: true, color:  `${colors.gray}` });
  const handleMouseLeave = () => setCursor({ active: false, color: `${colors.black}` });
  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ marginLeft: '5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
      {children}
    </div>
  );
};

const LinkedInIcon = ({ link }) => {
  const { setCursor } = useContext(CursorContext);
  const handleMouseEnter = () => setCursor({ active: true, color: colors.red });
  const handleMouseLeave = () => setCursor({ active: false, color: `${colors.gray}` });
  return (
    <a style={{ fontSize: '1.1em', display: 'inline-flex', alignItems: 'center', marginLeft: '0.3em' }} onMouseEnter={handleMouseEnter} 
    onMouseLeave={handleMouseLeave} href={link} target="_blank" rel="noopener noreferrer">
      <FaLinkedin style={{ color: "black" }}
      onMouseOver={(e) => e.currentTarget.style.color = '#3b82f6'} 
      onMouseOut={(e) => e.currentTarget.style.color = colors.black}/>
    </a>
  );
};

const StartupContentMobileContainer = ({ company }) => {

  const normalCursorHandlers = useCursorHandlers();

  switch (company.name) {
    case "Resia":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px', justifyContent: 'space-evenly' }}>
              <div style={{ display: 'flex', textAlign: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={claySeifertHeadshot} 
                    alt="Clay Seifert" 
                    style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Clay Seifert <LinkedInIcon link="https://www.linkedin.com/in/clay-seifert/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CEO
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', textAlign: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={seyeonHanHeadshot} 
                    alt="Seyeong Han" 
                    style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Seyeong Han <LinkedInIcon link="https://www.linkedin.com/in/seyeong-han/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CTO
                  </p>
                </div>
              </div>
            </div>
            <p style={{ textAlign: 'center', marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
            Resia helps contractors win more projects with instant designs and estimates that give homeowners confidence.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://forms.gle/AaqN6NHxU2d2hga47" target="_blank" >
                View Intern Roles →
                </a></p>
        </SCMobileContainer>
      )
      case "Livegate":
        return (
          <SCMobileContainer>
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px', justifyContent: 'space-evenly' }}>
                <div style={{ display: 'flex', textAlign: 'center' }}>
                  <div style={{ textAlign: 'center' }}>
                    <img 
                      src={adolfoGarcialHeadshot} 
                      alt="Adolfo Garcia" 
                      style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'center', overflow: 'hidden' }} 
                    />
                    <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Adolfo Garcia <LinkedInIcon link="https://www.linkedin.com/in/adolfo-garcia-capetillo-324539266/" />
                    </h3>
                    <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      CEO
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex', textAlign: 'center' }}>
                  <div style={{ textAlign: 'center' }}>
                    <img 
                      src={adityaPrasadHeadshot} 
                      alt="Aditya Prasad" 
                      style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                    />
                    <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Aditya Prasad <LinkedInIcon link="https://www.linkedin.com/in/aditya05prasad/" />
                    </h3>
                    <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      CTO
                    </p>
                  </div>
                </div>
              </div>
              <p style={{ textAlign: 'center', marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
              Livegate is a live communications platform that lets people chat about sporting events as they're happening in real time.
              </p>
              <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
              <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://forms.gle/JAqTKtWyf86kqVhf9" target="_blank" >
              View Intern Roles →
              </a></p>
          </SCMobileContainer>
        )
    case "CURA":
      return (
      <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={aakritiKamalHeadshot} 
                alt="Aakriti Kamal" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`,  width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Aakriti Kamal <LinkedInIcon link="https://www.linkedin.com/in/aakriti-kamal/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                CEO
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          Cura is an AI-powered app providing tailored support for family caregivers of mentally ill.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://forms.gle/uWn8diqRmXtEajDLA" target="_blank" >
          View Intern Roles →
          </a></p>

      </SCMobileContainer>
      )
    case "Suits":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={shreyasSatewarHeadshot} 
                alt="Shreyas Satewar" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`,  width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0px', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Shreyas Satewar <LinkedInIcon link="https://www.linkedin.com/in/shreyas-satewar/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                CEO
              </p>
              <p style={{ textAlign: 'center', marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
              Suits enables users to join, create, and claim compensation from class action settlements.
              </p>
              <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
              <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://forms.gle/tSaA1euatd5Jh7oQ9" target="_blank" >
              View Intern Roles →
              </a></p>
            </div>
          </div>
        </SCMobileContainer>
      )
  
    case "cacao.tax":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={joseYrigoyenHeadshot} 
                alt="Jose Yrigoyen" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`,  width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Jose Yrigoyen <LinkedInIcon link="https://www.linkedin.com/in/jmyrigoyen/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                CEO
              </p>
              <p style={{ textAlign: 'center', marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
              Bringing the tax-free benefit to international shoppers, starting with individual tax refunds.
              </p>
              <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
              <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://forms.gle/cBD9jh8vRoxbisZk7" target="_blank" >
              View Intern Roles →
              </a></p>
            </div>
          </div>
        </SCMobileContainer>
      )
    case "ClioVis":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={erikaBsumekHeadshot} 
                alt="Erika Bsumek" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Erika Bsumek <LinkedInIcon link="https://www.linkedin.com/in/erika-bsumek-7806461b0/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                CEO
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          ClioVis enables any field to visualize connections over time, serving education, research, business, and data storytelling with collaborative timelines.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://cliovis.com/" target="_blank" rel="noopener noreferrer" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "Pinpoint Irrigation":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px', justifyContent: 'space-evenly' }}>
              <div style={{ display: 'flex', textAlign: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={stephenHerreraHeadshot} 
                    alt="Stephen Herrera" 
                    style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'center', overflow: 'hidden' }} 
                  />
                  <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Stephen Herrera <LinkedInIcon link="https://www.linkedin.com/in/herrerastephen" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CEO
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', textAlign: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={kevinHartzogHeadshot} 
                    alt="Kevin Hartzog" 
                    style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Kevin Hartzog <LinkedInIcon link="https://www.linkedin.com/in/kevin-hartzog-365041167/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CTO
                  </p>
                </div>
              </div>
            </div>
            <p style={{ textAlign: 'center', marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
            Pinpoint Irrigation offers a smart sprinkler system that uses real-time, variable spray patterns to deliver water precisely and efficiently.
            </p>
            <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
            <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.pinpointirrigation.com/" target="_blank" rel="noopener noreferrer" >
            View Website →
            </a></p>
        </SCMobileContainer>
      )
    case "InternNest":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px', justifyContent: 'space-between', padding: '0 10px' }}>
              <div style={{ textAlign: 'center', flex: '1' }}>
                <img 
                  src={shreyanKattaHeadshot} 
                  alt="Shreyan Katta" 
                  style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                />
                <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Shreyan Katta <LinkedInIcon link="https://www.linkedin.com/in/shreyan-katta/" />
                </h3>
                <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  CEO
                </p>
              </div>
              <div style={{ textAlign: 'center', flex: '1' }}>
                <img 
                  src={harshithSadhuHeadshot} 
                  alt="Harshith Sadhu" 
                  style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                />
                <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Harshith Sadhu <LinkedInIcon link="https://www.linkedin.com/in/harshithsadhu/" />
                </h3>
                <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  CTO
                </p>
              </div>
              <div style={{ textAlign: 'center', flex: '1' }}>
                <img 
                  src={avanishShilpiHeadshot} 
                  alt="Avanishwarsai Shilpi" 
                  style={{ marginTop: '5px', borderRadius: '25%', border: `2px solid ${colors.red}`, width: '100px', height: '100px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                />
                <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Avanishwarsai Shilpi <LinkedInIcon link="https://www.linkedin.com/in/avanish-shilpi/" />
                </h3>
                <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.7em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  CTO
                </p>
              </div>
            </div>
            <p style={{ textAlign: 'center', marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
            InternNest helps interns find housing, roommates, or sublease their own place, making relocation easy, affordable, and flexible.
            </p>
            <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
            <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://internsublease.com/" target="_blank" rel="noopener noreferrer" >
            View Website →
            </a></p>
        </SCMobileContainer>
      )
    case "Spice-a-bowl":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={ivyFanHeadshot} 
                alt="Ivy Fan" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Ivy Fan <LinkedInIcon link="https://www.linkedin.com/in/ivysfan/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                CEO
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          Spice-A-Bowl offers all-in-one spice cards to bring the world's flavors to every home kitchen with ease and fun.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://spiceabowl.com/" target="_blank" rel="noopener noreferrer" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "Phenom":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={coleNevinsHeadshot} 
                alt="Cole Nevins" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Cole Nevins <LinkedInIcon link="https://www.linkedin.com/in/cnevins" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                CEO
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          Phenom bridges the gap between youth sports content needs and freelance creatives, delivering high-quality media through a frictionless hiring process.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.allphenom.com/" target="_blank" rel="noopener noreferrer" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "Makistry":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={parthMehtaHeadshot} 
                alt="Parth Mehta" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Parth Mehta <LinkedInIcon link="https://www.linkedin.com/in/parth-mehta100" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                CEO
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          AI-powered physical product design platform that democratizes and revolutionizes innovation by making design faster, easier, and smarter.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://makistry.com/" target="_blank" rel="noopener noreferrer" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "GigaCarbon":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={saahilSinhaHeadshot} 
                alt="Saahil Sinha" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Saahil Sinha <LinkedInIcon link="https://www.linkedin.com/in/saahil1sinha2025/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          GigaCarbon builds audit-grade measurement infrastructure that converts real-world transport behavior into verifiable, conservative emissions data.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.5ceco.com/" target="_blank" rel="noopener noreferrer" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "REGA":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={jonathanTeubalHeadshot} 
                alt="Jonathan Teubal" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Jonathan Teubal <LinkedInIcon link="https://www.linkedin.com/in/jonyteubal/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={ofriElbaumHeadshot} 
                alt="Ofri Elbaum" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Ofri Elbaum <LinkedInIcon link="https://www.linkedin.com/in/ofrielb/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          Rega is a screen time blocking app that turns everyday objects and places into physical keys for focus.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://joinrega.com/" target="_blank" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "tacite.ai":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={yuxuanCaoHeadshot} 
                alt="Yuxuan Cao" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Yuxuan Cao <LinkedInIcon link="https://www.linkedin.com/in/yuxuan-cao-4b235110b/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={viviDengHeadshot} 
                alt="Vivi Deng" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Vivi Deng <LinkedInIcon link="https://www.linkedin.com/in/chenweideng/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={andreSandovalHeadshot} 
                alt="Andre Sandoval" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Andre Sandoval <LinkedInIcon link="https://www.linkedin.com/in/andre-sandoval01/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          Tacite AI builds a private assistant for scientists, doctors, and industrial experts in high-stakes, regulated fields that turns scattered work into trustworthy answers—and preserves the hard-won tacit know-hows that usually lives only in people’s heads. 
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.tacite.ai/" target="_blank" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "Part Scout":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={chaseErikssonHeadshot} 
                alt="Chase Eriksson" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Chase Eriksson <LinkedInIcon link="https://www.linkedin.com/in/chase-eriksson/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          Part Scout tells commercial auto part recyclers what parts are worth selling.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.partscoutai.com/" target="_blank" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )
    case "Tape Sports":
      return (
        <SCMobileContainer>
          <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={gabrielPatinoHeadshot} 
                alt="Gabriel Patino" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Gabriel Patino <LinkedInIcon link="https://www.linkedin.com/in/gapatino/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
            <div style={{ textAlign: 'center', marginTop: '5px' }}>
              <img 
                src={lukeZunamonHeadshot} 
                alt="Luke Zunamon" 
                style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '125px', height: '125px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
              />
              <h3 style={{ color: colors.black, marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Luke Zunamon <LinkedInIcon link="https://www.linkedin.com/in/luke-zunamon/" />
              </h3>
              <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.8em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
              </p>
            </div>
          </div>  
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
          Tape Sports is a software platform that uses computer vision, multi-camera capture, and automated editing pipelines to produce athlete-specific reels and enable scalable highlight generation.
          </p>
          <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
          <a style={{ fontSize: '0.65em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://tape-sports.com/" target="_blank" >
          View Website →
          </a></p>
        </SCMobileContainer>
      )                
    // case "Thrive Education":
    //   return (
    //     <SCMobileContainer>
    //        <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px', fontSize: '0.55em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
    //        Thrive Education personalizes diabetes education through AI and provider-patient interaction.
    //         </p>
    //         <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
    //           <div style={{ textAlign: 'center', marginTop: '2px' }}>
    //             <img 
    //               src={devRandalpuraHeadshot} 
    //               alt="Dev Randalpura" 
    //               style={{ marginTop: '5px', borderRadius: '50%', width: '80px', height: '80px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
    //             />
    //             <h3 style={{ color: colors.black, marginTop: '0.3em', textAlign: 'center', fontSize: '0.65em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //             Dev Randalpura <LinkedInIcon link="https://www.linkedin.com/in/dev-randalpura-8533a81b7/" />
    //             </h3>
    //           </div>
    //         </div>
    //         <div style={{ display: 'flex', flexDirection: 'row', marginTop: '-15px', justifyContent: 'space-evenly' }}>
    //           <div style={{ display: 'flex', textAlign: 'center' }}>
    //             <div style={{ textAlign: 'center' }}>
    //               <img 
    //                 src={rohanPatelHeadshot} 
    //                 alt="Rohan Patel" 
    //                 style={{ marginTop: '5px', borderRadius: '50%', width: '80px', height: '80px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
    //               />
    //               <h3 style={{ color: colors.black, marginTop: '0.3em', textAlign: 'center', fontSize: '0.65em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //               Rohan Patel <LinkedInIcon link="https://www.linkedin.com/in/rohan-r-patel/" />
    //               </h3>
    //             </div>
    //           </div>
    //           <div style={{ display: 'flex', textAlign: 'center' }}>
    //             <div style={{ textAlign: 'center' }}>
    //               <img 
    //                 src={shvetanKattaHeadshot} 
    //                 alt="Shvetan Katta" 
    //                 style={{ marginTop: '5px', borderRadius: '50%', width: '80px', height: '80px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
    //               />
    //               <h3 style={{ color: colors.black, marginTop: '0.3em', textAlign: 'center', fontSize: '0.65em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //               Shvetan Katta <LinkedInIcon link="https://www.linkedin.com/in/shvetan-katta/" />
    //               </h3>
    //             </div>
    //           </div>
    //         </div>
    //         <h2 style={{marginTop: '0px', textAlign: 'center', fontSize: '0.65em', fontWeight: '200', fontFamily: 'ReadexPro, sans-serif' }}>Internship Roles Available</h2>
    //         <div style={{  marginLeft: '15px', marginRight: '15px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
    //           <div style={{ border: `1.2px solid ${colors.red}`, borderRadius: '20px', padding: '2px' }}>
    //             <h3 style={{ textAlign: 'center', fontSize: '0.65em', fontFamily: 'ReadexPro, sans-serif'  }}>Tech</h3>
    //             <ul style={{ marginTop: '-10px', fontSize: '0.55em', fontWeight: '200', fontFamily: 'Merriweather, serif' }}>
    //               <li>Develop and integrate AI features into the mobile app</li>
    //               <li>Create a data analytics dashboard (React Native with TypeScript, SQL)</li>
    //               <li>Collect and implement patient/clinician feedback</li>
    //             </ul>
    //           </div>
    //         </div>
    //     </SCMobileContainer>
    //     )
   }
};
const StartupContentContainer = ({ company }) => {
  const { setCursor } = useContext(CursorContext);
  const normalCursorHandlers = useCursorHandlers();
  const handleMouseEnter = () => setCursor({ active: false, color: `${colors.gray}` });
  const handleMouseLeave = () => setCursor({ active: false, color: "black" });

  switch (company.name) {
    case "ClioVis":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '45%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={erikaBsumekHeadshot} 
                    alt="Erika Bsumek" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Erika Bsumek <LinkedInIcon link="https://www.linkedin.com/in/erika-bsumek-7806461b0/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CEO
                  </p>
                </div>
              </div>
              <div style={{ width: '50%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitle style={{ marginTop: '10px', marginBottom: '0em', color: colors.red }}> 
                  {company.name}
                </StartupTitle>
                <p style={{ marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                  ClioVis enables any field to visualize connections over time, serving education, research, business, and data storytelling with collaborative timelines.
                </p>
                <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://cliovis.com/" target="_blank" rel="noopener noreferrer" >
                View Website →
                </a></p>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      ); 
      case "Pinpoint Irrigation":
        return (
          <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <InnerSCContainer>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
                <div style={{ width: '60%', display: 'flex', justifyContent: 'space-around' }}>
                  <div style={{ textAlign: 'center' }}>
                    <img 
                      src={stephenHerreraHeadshot} 
                      alt="Stephen Herrera" 
                      style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'center', overflow: 'hidden' }} 
                    />
                    <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Stephen Herrera <LinkedInIcon link="https://www.linkedin.com/in/herrerastephen" />
                    </h3>
                    <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      CEO
                    </p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <img 
                      src={kevinHartzogHeadshot} 
                      alt="Kevin Hartzog" 
                      style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                    />
                    <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Kevin Hartzog <LinkedInIcon link="https://www.linkedin.com/in/kevin-hartzog-365041167/" />
                    </h3>
                    <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      CTO
                    </p>
                  </div>
                </div>
                <div style={{ width: '35%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <StartupTitle style={{ marginTop: '10px', marginBottom: '0em', color: colors.red }}> 
                    {company.name}
                  </StartupTitle>
                  <p style={{ marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                  Pinpoint Irrigation offers a smart sprinkler system that uses real-time, variable spray patterns to deliver water precisely and efficiently.
                  </p>
                  <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
                  <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.pinpointirrigation.com/" target="_blank" rel="noopener noreferrer" >
                  View Website →
                  </a></p>
                </div>
              </div>
            </InnerSCContainer>
          </SCContainer>
        );
    case "InternNest":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
                <div style={{ textAlign: 'center', flex: '1' }}>
                  <img 
                    src={shreyanKattaHeadshot} 
                    alt="Shreyan Katta" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Shreyan Katta 
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CEO <LinkedInIcon link="https://www.linkedin.com/in/shreyan-katta/" />
                  </p>
                </div>
                <div style={{ textAlign: 'center', flex: '1' }}>
                  <img 
                    src={harshithSadhuHeadshot} 
                    alt="Harshith Sadhu" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Harshith Sadhu 
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CTO <LinkedInIcon link="https://www.linkedin.com/in/harshithsadhu/" />
                  </p>
                </div>
                <div style={{ textAlign: 'center', flex: '1' }}>
                  <img 
                    src={avanishShilpiHeadshot} 
                    alt="Avanishwarsai Shilpi" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Avanishwarsai Shilpi 
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CTO <LinkedInIcon link="https://www.linkedin.com/in/avanish-shilpi/" />
                  </p>
                </div>
              </div>
              <div style={{ width: '35%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitle style={{ marginTop: '10px', marginBottom: '0em', color: colors.red }}> 
                  {company.name}
                </StartupTitle>
                <p style={{ marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                InternNest helps interns find housing, roommates, or sublease their own place, making relocation easy, affordable, and flexible.
                </p>
                <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://internsublease.com/" target="_blank" rel="noopener noreferrer" >
                View Website →
                </a></p>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    case "Spice-a-bowl":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitleAlt style={{ fontSize: '7vmin', color: colors.red, marginLeft: '30px'}}>{ company.name }</StartupTitleAlt>
                <p style={{ marginLeft: '30px', marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                Spice-A-Bowl offers all-in-one spice cards to bring the world's flavors to every home kitchen with ease and fun.
                </p>
                <p style={{textAlign: 'left', marginLeft: '30px', marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://spiceabowl.com/" target="_blank" rel="noopener noreferrer" >
                View Website →
                </a></p>
              </div>
              <div style={{ width: '35%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={ivyFanHeadshot} 
                    alt="Ivy Fan" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                   <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                   Ivy Fan <LinkedInIcon link="https://www.linkedin.com/in/ivysfan/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CEO
                  </p>
                </div>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    case "Phenom":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitleAlt style={{ fontSize: '7vmin', color: colors.red, marginLeft: '30px'}}>{ company.name }</StartupTitleAlt>
                <p style={{ marginLeft: '30px', marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                Phenom bridges the gap between youth sports content needs and freelance creatives, delivering high-quality media through a frictionless hiring process.
                </p>
                <p style={{textAlign: 'left', marginLeft: '30px', marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.allphenom.com/" target="_blank" rel="noopener noreferrer" >
                View Website →
                </a></p>
              </div>
              <div style={{ width: '35%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={coleNevinsHeadshot} 
                    alt="Cole Nevins" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Cole Nevins <LinkedInIcon link="https://www.linkedin.com/in/cnevins" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CEO
                  </p>
                </div>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
      case "Makistry":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitleAlt style={{ fontSize: '7vmin', color: colors.red, marginLeft: '30px'}}>{ company.name }</StartupTitleAlt>
                <p style={{ marginLeft: '30px', marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                AI-powered physical product design platform that democratizes and revolutionizes innovation by making design faster, easier, and smarter.
                </p>
                <p style={{textAlign: 'left', marginLeft: '30px', marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://makistry.com/" target="_blank" rel="noopener noreferrer" >
                View Website →
                </a></p>
              </div>
              <div style={{ width: '35%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={parthMehtaHeadshot} 
                    alt="Parth Mehta" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Parth Mehta <LinkedInIcon link="https://www.linkedin.com/in/parth-mehta100" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    CEO
                  </p>
                </div>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    case "GigaCarbon":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitleAlt style={{ fontSize: '7vmin', color: colors.red, marginLeft: '30px'}}>{ company.name }</StartupTitleAlt>
                <p style={{ marginLeft: '30px', marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                GigaCarbon builds audit-grade measurement infrastructure that converts real-world transport behavior into verifiable, conservative emissions data.
                </p>
                <p style={{textAlign: 'left', marginLeft: '30px', marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.5ceco.com/" target="_blank" rel="noopener noreferrer" >
                View Website →
                </a></p>
              </div>
              <div style={{ width: '35%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={saahilSinhaHeadshot} 
                    alt="Saahil Sinha" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Saahil Sinha <LinkedInIcon link="https://www.linkedin.com/in/saahil1sinha2025/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    case "REGA":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={jonathanTeubalHeadshot} 
                    alt="Jonathan Teubal" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Jonathan Teubal <LinkedInIcon link="https://www.linkedin.com/in/jonyteubal/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={ofriElbaumHeadshot} 
                    alt="Ofri Elbaum" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Ofri Elbaum <LinkedInIcon link="https://www.linkedin.com/in/ofrielb/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
              </div>
              <div style={{ width: '35%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitle style={{ marginTop: '10px', marginBottom: '0em', color: colors.red }}> 
                  {company.name}
                </StartupTitle>
                <p style={{ marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                Rega is a screen time blocking app that turns everyday objects and places into physical keys for focus.
                </p>
                <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://joinrega.com/" target="_blank" >
                View Website →
                </a></p>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    case "tacite.ai":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
                <div style={{ textAlign: 'center', flex: '1' }}>
                  <img 
                    src={yuxuanCaoHeadshot} 
                    alt="Yuxuan Cao" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Yuxuan Cao <LinkedInIcon link="https://www.linkedin.com/in/yuxuan-cao-4b235110b/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
                <div style={{ textAlign: 'center', flex: '1' }}>
                  <img 
                    src={viviDengHeadshot} 
                    alt="Vivi Deng" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Vivi Deng <LinkedInIcon link="https://www.linkedin.com/in/chenweideng/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
                <div style={{ textAlign: 'center', flex: '1' }}>
                  <img 
                    src={andreSandovalHeadshot} 
                    alt="Andre Sandoval" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Andre Sandoval <LinkedInIcon link="https://www.linkedin.com/in/andre-sandoval01/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
              </div>
              <div style={{ width: '35%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden' }}>
                <StartupTitle style={{ marginTop: '10px', marginBottom: '0em', color: colors.red, fontSize: '6vmin' }}> 
                  {company.name}
                </StartupTitle>
                <p style={{ marginTop: '0.3em', fontSize: '0.9em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                Tacite AI builds a private assistant for scientists, doctors, and industrial experts in high-stakes, regulated fields that turns scattered work into trustworthy answers—and preserves the hard-won tacit know-hows that usually lives only in people's heads.
                </p>
                <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.tacite.ai/" target="_blank" >
                View Website →
                </a></p>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    case "Part Scout":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <StartupTitleAlt style={{ fontSize: '7vmin', color: colors.red, marginLeft: '30px'}}>{ company.name }</StartupTitleAlt>
                <p style={{ marginLeft: '30px', marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                Part Scout tells commercial auto part recyclers what parts are worth selling.
                </p>
                <p style={{textAlign: 'left', marginLeft: '30px', marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://www.partscoutai.com/" target="_blank" >
                View Website →
                </a></p>
              </div>
              <div style={{ width: '35%', display: 'flex', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={chaseErikssonHeadshot} 
                    alt="Chase Eriksson" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Chase Eriksson <LinkedInIcon link="https://www.linkedin.com/in/chase-eriksson/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    case "Tape Sports":
      return (
        <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerSCContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              <div style={{ width: '60%', display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={gabrielPatinoHeadshot} 
                    alt="Gabriel Patino" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Gabriel Patino <LinkedInIcon link="https://www.linkedin.com/in/gapatino/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <img 
                    src={lukeZunamonHeadshot} 
                    alt="Luke Zunamon" 
                    style={{ marginTop: '10px', borderRadius: '25%', border: `3px solid ${colors.red}`, width: '145px', height: '145px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
                  />
                  <h3 style={{ marginTop: '0.3em', marginBottom: '0', textAlign: 'center', fontSize: '1em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  Luke Zunamon <LinkedInIcon link="https://www.linkedin.com/in/luke-zunamon/" />
                  </h3>
                  <p style={{ marginTop: '0', textAlign: 'center', fontSize: '0.9em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    
                  </p>
                </div>
              </div>
              <div style={{ width: '35%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden' }}>
                <StartupTitle style={{ marginTop: '10px', marginBottom: '0em', color: colors.red, fontSize: '5.8vmin' }}> 
                  {company.name}
                </StartupTitle>
                <p style={{ marginTop: '0.3em', fontSize: '1em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
                Tape Sports is a software platform that uses computer vision, multi-camera capture, and automated editing pipelines to produce athlete-specific reels and enable scalable highlight generation.
                </p>
                <p style={{textAlign: 'center',  marginTop: '0.3em', marginBottom: '0px' }}>
                <a style={{ fontSize: '0.8em', fontWeight: '300', fontFamily: 'Merriweather, serif', color: colors.red }} {...normalCursorHandlers} href="https://tape-sports.com/" target="_blank" >
                View Website →
                </a></p>
              </div>
            </div>
          </InnerSCContainer>
        </SCContainer>
      );
    // case "Thrive Education":
    //   return (
    //     <SCContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
    //       <InnerSCContainerAlt>
    //         <div style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
    //           <div style={{ margin: '0px'}}>
    //             <StartupTitleAlt style={{ fontSize: '6.25vmin'}}>{ company.name }</StartupTitleAlt>
    //             <p style={{ marginLeft: '30px', marginTop: '0.3em', fontSize: '0.77em', fontWeight: '300', fontFamily: 'Merriweather, serif' }}>
    //             Thrive Education personalizes diabetes education through AI and provider-patient interaction.
    //             </p>
    //           </div>
    //           <h2 style={{ marginTop: '0px', textAlign: 'center', fontSize: '1.2em', fontWeight: '200', fontFamily: 'ReadexPro, sans-serif' }}>Internship Roles Available</h2>
    //           <div style={{ marginLeft: '15px', marginRight: '15px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
    //             <div style={{ border: `1.5px solid ${colors.red}`, borderRadius: '20px', }}>
    //               <h3 style={{ textAlign: 'center', fontSize: '1em', fontFamily: 'ReadexPro, sans-serif'  }}>Tech</h3>
    //               <ul style={{ marginTop: '-10px', fontSize: '0.8em', fontWeight: '200', fontFamily: 'Merriweather, serif', paddingRight: '1px' }}>
    //                 <li>Develop and integrate AI features into the mobile app</li>
    //                 <li>Create a data analytics dashboard (React Native with TypeScript, SQL)</li>
    //                 <li>Collect and implement patient/clinician feedback</li>
    //               </ul>
    //             </div>
    //           </div>
    //         </div>
    //         <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '30%', alignItems: 'center', height: '100%'}}>
    //           <div style={{ textAlign: 'center' }}>
    //             <img 
    //               src={devRandalpuraHeadshot} 
    //               alt="Dev Randalpura" 
    //               style={{ marginTop: '10px', borderRadius: '50%', width: '120px', height: '120px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
    //             />
    //             <h3 style={{ marginTop: '0.3em', textAlign: 'center', fontSize: '0.85em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //             Dev Randalpura <LinkedInIcon link="https://www.linkedin.com/in/dev-randalpura-8533a81b7/" />
    //           </h3>
    //           </div>
    //           <div style={{ textAlign: 'center' }}>
    //             <img 
    //               src={shvetanKattaHeadshot} 
    //               alt="Shvetan Katta" 
    //               style={{ marginTop: '10px', borderRadius: '50%', width: '120px', height: '120px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
    //             />
    //             <h3 style={{ marginTop: '0.3em', textAlign: 'center', fontSize: '0.85em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //             Shvetan Katta <LinkedInIcon link="https://www.linkedin.com/in/shvetan-katta/" />
    //           </h3>
    //           </div>
    //         </div>
    //         <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', height: '100%', alignItems: 'center' }}>
    //           <img 
    //             src={rohanPatelHeadshot} 
    //             alt="Rohan Patel" 
    //             style={{ marginTop: '10px', borderRadius: '50%', width: '120px', height: '120px', objectFit: 'cover', objectPosition: 'top', overflow: 'hidden' }} 
    //           />
    //           <h3 style={{ marginTop: '0.3em', textAlign: 'center', fontSize: '0.85em', fontWeight: '300', fontFamily: 'ReadexPro, sans-serif', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //             Rohan Patel <LinkedInIcon link="https://www.linkedin.com/in/rohan-r-patel/" />
    //           </h3>
    //         </div>
            
    //       </InnerSCContainerAlt>
    //     </SCContainer>
    //   );
  }
};



function CurrentComp() {
  const cohortDesktopLayout = useCohortDesktopLayout();
  const [activeCohortId, setActiveCohortId] = useState("sp26");
  const activeTab = COHORT_TABS.find((t) => t.id === activeCohortId) ?? COHORT_TABS[0];
  const companies = activeTab.companies;

  const [company, setCompany] = useState(() => spring2026PortfolioInfo[0]);
  const companiesRef = useRef(spring2026PortfolioInfo);
  companiesRef.current = companies;

  useEffect(() => {
    const list = COHORT_TABS.find((t) => t.id === activeCohortId)?.companies ?? spring2026PortfolioInfo;
    setCompany(list[0]);
  }, [activeCohortId]);

  useEffect(() => {
    const savedPosition = sessionStorage.getItem("scrollPosition");
    if (savedPosition !== null) {
      window.scrollTo({
        top: parseInt(savedPosition, 10),
        behavior: "instant",
      });
      sessionStorage.removeItem("scrollPosition");
    }
  }, []);

  const cursorHandlers = useSectionCursor({ color: colors.black });

  const companyCursorHandlers = useCursorHandlers({
    hoverOptions: { type: "default", color: colors.red },
    defaultOptions: { type: "default", color: colors.black },
  });

  const handleSlideChange = (swiper) => {
    const list = companiesRef.current;
    const currentCompany = list[swiper.activeIndex];
    if (currentCompany) setCompany(currentCompany);
  };

  return (
    <SectionContainer {...cursorHandlers}>
      <CohortSectionHeader>
        <CohortScreenReaderTitle>Startup cohorts</CohortScreenReaderTitle>
        <CohortTabList role="tablist" aria-label="Choose cohort">
          {COHORT_TABS.map((tab) => (
            <CohortTab
              key={tab.id}
              type="button"
              role="tab"
              id={`cohort-tab-${tab.id}`}
              aria-selected={activeCohortId === tab.id}
              aria-controls="cohort-startups-panel"
              $active={activeCohortId === tab.id}
              onClick={() => setActiveCohortId(tab.id)}
            >
              {tab.label}
            </CohortTab>
          ))}
        </CohortTabList>
      </CohortSectionHeader>
      <CohortPanel
        id="cohort-startups-panel"
        role="tabpanel"
        aria-labelledby={`cohort-tab-${activeCohortId}`}
      >
        {cohortDesktopLayout ? (
          <PresentCohortContainer key={activeCohortId}>
            <SwiperContainer>
              <Swiper
                effect={"cards"}
                grabCursor={true}
                spaceBetween={30}
                modules={[EffectCards, Navigation]}
                className="mySwiper"
                onSlideChange={handleSlideChange}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
              >
                {companies.map((c) => (
                  <SwiperSlide key={c.name}>
                    <Logo
                      src={c.logo}
                      name={c.name}
                      {...companyCursorHandlers}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <SwiperArrowsAndProgress>
                <div />
                <div className="swiper-button-prev">
                  <LuArrowLeftCircle style={{ color: `${colors.red}`, fontSize: "25px" }} />
                </div>
                <div className="swiper-button-next">
                  <LuArrowRightCircle style={{ color: `${colors.red}`, fontSize: "25px" }} />
                </div>
                <div />
              </SwiperArrowsAndProgress>
            </SwiperContainer>
            <DescriptionContainer>
              <StartupContentContainer company={company} />
            </DescriptionContainer>
          </PresentCohortContainer>
        ) : (
          <PresentMobileCohortContainer key={activeCohortId}>
            <Swiper
              style={{ height: "72vh" }}
              direction={"vertical"}
              modules={[Navigation]}
              spaceBetween={25}
              navigation={{
                nextEl: ".swiper-mobile-button-next",
                prevEl: ".swiper-mobile-button-prev",
              }}
              className="mySwiper"
              onSlideChange={handleSlideChange}
            >
              {companies.map((c) => (
                <SwiperSlide
                  key={c.name}
                  style={{ height: "auto", display: "flex", justifyContent: "center" }}
                >
                  <InnerSCContainerMobile>
                    <TitleRowMobile>
                      <LogoMobile src={c.logo} />
                      <StartupTitleMobile style={{ marginBottom: "0.1em" }}>
                        {c.name}
                      </StartupTitleMobile>
                    </TitleRowMobile>
                    <StartupContentMobileContainer company={c} />
                  </InnerSCContainerMobile>
                </SwiperSlide>
              ))}
            </Swiper>
            <SwiperArrowsAndProgressTablet>
              <div />
              <div className="swiper-mobile-button-prev">
                <LuArrowUpCircle style={{ color: `${colors.red}`, fontSize: "25px" }} />
              </div>
              <div className="swiper-mobile-button-next">
                <LuArrowDownCircle style={{ color: `${colors.red}`, fontSize: "25px" }} />
              </div>
              <div />
            </SwiperArrowsAndProgressTablet>
          </PresentMobileCohortContainer>
        )}
      </CohortPanel>
    </SectionContainer>
  );
}

export default CurrentComp;